import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Logo from "../../../assets/images/Logo.svg";
import { Formik } from "formik";
import LoginBanner from "../../../assets/images/login-banner.png";
import { loginWithUserNameAndPassword } from "../../../services/authService";
import Loader from "../../../components/common/Loader";
import storage from "../../../helpers/storage";
import InputText from "../../../components/common/InputText";
import InputPassword from "../../../components/common/InputPassword";
import { LoginSchema } from "../../../validations/Auth";
import { Scrollbars } from "react-custom-scrollbars";
import Box from "@mui/material/Box";
import { nameBasedRoutes } from "../../../router/public";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import { CUSTOMER, INSPECTOR } from "../../../constants/roles";
import { toast } from "react-toastify";
import { MESSAGES } from "../../../constants/messages";

import ReCAPTCHA from "react-google-recaptcha";
import { MyContext } from "MyProvider";

export const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [captchaCode, setCaptchaCode] = useState("");
  const { setAddSecondaryUser }=useContext(MyContext)

  const rememberMe: { email: string; isChecked: boolean; password: string } =
    storage?.getData("remember-me");

  const initialValues = {
    email: rememberMe ? rememberMe.email : "",
    password: rememberMe ? rememberMe.password : "",
    captcha: "",
  };
  const recaptchaRef = useRef<any>(null);

  useEffect(() => {
    if (storage.getToken() != null) {
      const userInfo = storage.getData("user-info");
      const role = userInfo ? userInfo?.role : "GUEST";
      
      if (role == INSPECTOR) {
        return navigate(nameBasedProtectedRoutes.iuserDashboard.path);
      } else {
        return navigate(nameBasedProtectedRoutes.dashborad.path);
      }
    }
  }, [navigate]);

  const onChangeCheckbox = (event: any) => {
    setIsChecked(event.target.checked);
  };

  const onChangeCaptchaCode = (value: any) => {
    setCaptchaCode(value);
  };

  const resetForm = () => {
    // recaptchaRef.current.reset();
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    // reset other form fields as needed
  };

  /**
   * Submit Method to call when user clicks on login button
   * @async
   * @param {string} email
   * @param {string} password
   * @param {string} captcha
   * @returns {*}
   */
  const submitForm = async (
    email: string,
    password: string,
    captcha: any,
    actions: any
  ) => {
    if (!captchaCode) {
      // resetForm();
      toast.error(MESSAGES.captchInvalid);
      return;
    }
    if (isChecked) {
      storage.setData("remember-me", { email, password, isChecked });
    } else {
      localStorage.removeItem("remember-me");
    }
    setLoading(true);
    const role = ["CUSTOMER", "INSPECTOR"];
    loginWithUserNameAndPassword({ email, password, role })
      .then((response) => {
        setLoading(false);
        setAddSecondaryUser(response.data.user.add_secondary_user);
        storage.setToken(response.data.tokens.access.token);
        storage.setRefreshToken(response.data.tokens.refresh.token);
        storage.setData("user-info", response.data.user);
        storage.setData("refresh-token", response.data.tokens.refresh);

        if (response.data.user.role == INSPECTOR) {
          navigate(nameBasedProtectedRoutes.iuserDashboard.path);
        } else {
          navigate(nameBasedProtectedRoutes.dashborad.path);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };
  return (
    <>
      <Scrollbars className="custome-scroll">
        <Row className="g-0 vh-100 position-relative">
          <Col md={6} lg={4} className="h-100">
            <div className="h-100  p-4 p-md-4 pe-md-0 position-relative ps-md-0 text-center w-100 pb-md-0">
              <Row className="align-items-center g-0 justify-content-center login-left-inner pb-3">
                <Col md={10} lg={10} xl={8} xxl={8}>
                  <div className="mb-2 pb-2">
                    <Link
                      to={nameBasedRoutes.home.path}
                      className="d-inline-block"
                    >
                      <Image
                        className="img-fluid"
                        src={Logo}
                        alt="Logo"
                        width={129}
                        height={130}
                      />
                    </Link>
                  </div>
                  <h1 className="d-inline-block fw-bold h4 mb-1 mt-1 pt-2 w-100">
                    Welcome To HESCO
                  </h1>
                  <h4 className="fs-18 fw-semibold">
                    Crane Inspection Document Portal
                  </h4>

                  <Formik
                    validationSchema={LoginSchema}
                    initialValues={initialValues}
                    onSubmit={(values, actions) => {
                      actions.setSubmitting(false);
                      submitForm(
                        values.email.trim(),
                        values.password,
                        values.captcha,
                        actions
                      );
                    }}
                  >
                    {({
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      touched,
                    }) => (
                      <Form
                        className="text-start pt-4"
                        noValidate
                        onSubmit={handleSubmit}
                      >
                        {/* <PermissionsGate
                                                scopes={[SCOPES.canEdit]}
                                            > */}
                        <InputText
                          controlId="email"
                          label="Email Address"
                          placeholder="Email Address"
                          touched={touched.email}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          errorsField={errors.email}
                          value={values.email}
                        />

                        <InputPassword
                          controlId="password"
                          label="Password"
                          placeholder="Enter Password"
                          touched={touched.password}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          errorsField={errors.password}
                          value={values.password}
                        />
                        {/* </PermissionsGate> */}

                        <Form.Group className="mb-3 pb-1">
                          <Row
                            xs="auto"
                            className="align-items-center justify-content-between gx-0"
                          >
                            <Col>
                              <Form.Check
                                id="rememberCheck"
                                checked={isChecked}
                                onChange={onChangeCheckbox}
                                className="fs-15"
                                type="checkbox"
                                label="Remember Me"
                              />
                            </Col>
                            <Col>
                              <Link
                                className="fw-bold text-decoration-none fs-14"
                                to={nameBasedRoutes.forgotPassword.path}
                              >
                                Forgot Password?
                              </Link>
                            </Col>
                          </Row>
                        </Form.Group>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={process.env.REACT_APP_CPATCHA_KEY}
                          onChange={onChangeCaptchaCode}
                        />
                        <br />
                        <Button
                          className="fw-bold w-100"
                          variant="primary"
                          type="submit"
                        >
                          Login
                        </Button>
                      </Form>
                    )}
                  </Formik>
                </Col>
              </Row>
              <Row className="bottom-0 g-0 left  row w-100 login-btm pt-3 pb-3 text-center ">
                <Col lg={12} xl={12} xxl={12}>
                  <Col lg={12}>
                    <h6 className="mb-0 fs-11 gray-color">
                      Don't have an account?
                    </h6>
                  </Col>
                  <Col lg={12}>
                    <Link
                      className="fw-bold text-decoration-none fs-14"
                      to={nameBasedRoutes.register.path}
                    >
                      Sign Up
                    </Link>
                  </Col>
                </Col>
              </Row>
            </div>
          </Col>

          <Col
            md={6}
            lg={8}
            className="mobileBannerActive h-100 position-fixed right-0"
          >
            <Image
              className="h-100  w-100"
              src={LoginBanner}
              alt="Login Banner"
            />
            <div className="bottom-0 h4 pb-3 position-absolute pt-3 w-100 white-color text-center posti right-text-overlapp mb-0">
              CRANE SAFETY EXPERTS
            </div>
          </Col>
        </Row>
      </Scrollbars>
      <Loader isLoading={loading} />
    </>
  );
};
